import React from "react";
import {CheckBadgeIcon, HandRaisedIcon, PencilIcon, ShieldExclamationIcon} from "@heroicons/react/20/solid";
import ValidationState from "../../models/enums/validation-state.ts";
import mergeClasses from "@/utils/merge-classes.ts";

interface ValidationBadgeProps extends React.HTMLAttributes<SVGSVGElement> {
    validation?: ValidationState;
}

const ValidationBadge: React.FC<ValidationBadgeProps> = ({validation, ...props}) => {
    let StatusIcon = HandRaisedIcon;
    let statusClasses = "fill-orange-500";
    
    switch (validation) {            
        case ValidationState.Validated:
            StatusIcon = CheckBadgeIcon;
            statusClasses = "fill-green-500 border-green-500";
            break;
        case ValidationState.ToValidate:
            StatusIcon = HandRaisedIcon;
            statusClasses = "fill-yellow-500 border-yellow-500";
            break;
        case ValidationState.ManuallyCompleted:
            StatusIcon = PencilIcon;
            statusClasses = "fill-blue-500 border-blue-500";
            break;
        case ValidationState.Refused:
            StatusIcon = ShieldExclamationIcon;
            statusClasses = "fill-rose-500 border-rose-500";
            break;
        default:
            StatusIcon = HandRaisedIcon;
            statusClasses = "fill-orange-500 border-orange-500";
            break;
    }
    
    return (
        <StatusIcon className={mergeClasses("p-1 border-2 rounded-full w-6.5", statusClasses,)} {...props}/>
    )
}

export default ValidationBadge;